import { Card, CardContent, Container, makeStyles} from "@material-ui/core";
import React from "react";
import Page from "./Page";
import Box from "@material-ui/core/Box";
import LoadingOverlay from 'react-loading-overlay-ts';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingTop: theme.spacing(3)
	},
    refreshButton: {
	    width: 60,
        position: "absolute",
        right: 24
    },
    grid: {
        flex: "1 1 auto",
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 180px)"
    }
}));

export const GridSkeleton = ({title, header, filter, isSearching, grid, isBlocked}) => {

	const classes = useStyles();

    return (
        <LoadingOverlay
          active={isBlocked || isSearching}
          spinner
          text='Wait'
        >
        <Page className={classes.root} title={title}>
			<Container maxWidth={false}>
                <Box mb={2}>
                    {header}
                </Box>
                <Card
                >
                    <CardContent className={classes.grid}>
                        {filter}
                        {grid}
                    </CardContent>
                </Card>

			</Container>
        </Page>
        </LoadingOverlay>
    );
}